import React from "react";
import { CPInput } from "../CPInput";
import { CPDropdown } from "../CPDropdown";
import {
  applyTaxTypeSelection,
  ESTIMATE_TAX_TYPE_OPTIONS,
  formatStandardTaxRateDisplay,
} from "../../helpers/estimateTax";

const CARD_STYLE = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(201,168,76,0.25)",
  borderRadius: "14px",
  padding: "14px",
  marginBottom: "10px",
};

export function TaxLineEditor({ lineNumber, line, onChange, disabled }) {
  function update(patch) {
    onChange({ ...line, ...patch });
  }

  function handleTypeChange(nextType) {
    onChange(applyTaxTypeSelection(line, nextType));
  }

  return (
    <div style={CARD_STYLE}>
      <div style={{ fontWeight: 600, marginBottom: "10px" }}>
        Tax Line {lineNumber}
      </div>

      <CPDropdown
        label="Tax Type"
        value={line.type}
        onChange={handleTypeChange}
        options={ESTIMATE_TAX_TYPE_OPTIONS}
        placeholder="Select tax type"
        disabled={disabled}
      />

      {line.type !== "custom" && (
        <CPInput
          label="Rate %"
          value={formatStandardTaxRateDisplay(line.type)}
          readOnly
          disabled
        />
      )}

      {line.type === "custom" && (
        <>
          <CPInput
            label="Tax Name"
            value={line.customName}
            onChange={(value) => update({ customName: value })}
            placeholder="e.g. Municipal Tax"
            disabled={disabled}
          />
          <CPInput
            label="Tax Rate"
            value={line.rate}
            onChange={(value) => update({ rate: value })}
            type="number"
            placeholder="0"
            disabled={disabled}
          />
        </>
      )}
    </div>
  );
}
